import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { map, type Observable } from 'rxjs';
import type { MultiItemResponse } from '../models/middleware/multi-item-response.model';
import type { QuestionItemModel as ServerQuestionItemModel } from '../models/middleware/question-item.model';
import type { QuestionItemModel } from '../models/question-item.model';

@Injectable({
  providedIn: 'root',
})
export class QuestionService {
  private readonly http = inject(HttpClient);
  private readonly url = `/api/authenticated/event/questions`;

  getQuestionItems(documentId: string): Observable<QuestionItemModel[]> {
    return this.http
      .get<MultiItemResponse<ServerQuestionItemModel>>(`${this.url}/${documentId}`)
      .pipe(map((response) => response.items.map((question) => this.convertToDisplayItem(question))));
  }

  private convertToDisplayItem(apiItem: ServerQuestionItemModel): QuestionItemModel {
    return {
      question: apiItem.question,
      answer: apiItem.answer,
      important: apiItem.important,
    };
  }
}
